import { createFileRoute } from '@tanstack/react-router';

import {
  PlanManagedAccountProgramTab,
  QueryBoundary
} from '../../../../../components';

const Page = () => {
  const params = Route.useParams();

  return (
    <QueryBoundary>
      <PlanManagedAccountProgramTab
        advisoryOrganizationId={params.advisoryOrganizationId}
        planId={params.planId}
      />
    </QueryBoundary>
  );
};

export const Route = createFileRoute(
  '/organizations/$advisoryOrganizationId/plans/$planId/managed-account-program'
)({
  component: Page
});
